import { Box, ListItemText, MenuItem, MenuList } from '@mui/material';
import { UserInvitationStatus } from 'generated/graphql';
import isEqual from 'lodash/isEqual';
import { Count, useStore } from 'react-admin';

export const userInvitationStatusFilters: Record<string, Record<string, string>> = {
  Accepted: { status: UserInvitationStatus.Accepted },
  All: {},
  Cancelled: { status: UserInvitationStatus.Cancelled },
  Pending: { status: UserInvitationStatus.Pending },
};

interface UserInvitationStatusFilterOption {
  key: string;
  label: string;
  filter: Record<string, string>;
}

export const userInvitationStatusFilterOptions: UserInvitationStatusFilterOption[] = [
  { filter: userInvitationStatusFilters.All, key: 'ALL', label: 'Všetky' },
  { filter: userInvitationStatusFilters.Accepted, key: 'ACCEPTED', label: 'Prijaté' },
  { filter: userInvitationStatusFilters.Cancelled, key: 'CANCELLED', label: 'Zrušené' },
  { filter: userInvitationStatusFilters.Pending, key: 'PENDING', label: 'Čakajúce' },
];

export const UserInvitationListAside: React.FC = () => {
  const [statusFilter, setStatusFilter] = useStore(
    'resources.userInvitations.list.statusFilter',
    userInvitationStatusFilters.All,
  );

  return (
    <Box flexShrink={0} mr={1} mt={7} order={-1} width={200}>
      <MenuList>
        {userInvitationStatusFilterOptions.map((it) => (
          <MenuItem key={it.key} onClick={() => setStatusFilter(it.filter)} selected={isEqual(statusFilter, it.filter)}>
            <ListItemText>{it.label}</ListItemText>
            <Count color="text.disabled" filter={it.filter} />
          </MenuItem>
        ))}
      </MenuList>
    </Box>
  );
};
